/** Money is stored in minor units (pence) with an ISO 4217 currency code. */
export function formatMoney(minor: number | null, currency: string | null): string {
  if (minor === null) return ''
  return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency ?? 'GBP' }).format(
    minor / 100,
  )
}
